module.exports = __webpack_public_path__ + "8aacda4dcfb2b3e3d96ebcd060b8971e.png";